import { useQuery } from 'react-query';
import { useMemo } from 'react';
import UnitTypeService from '../../../services/unitTypeService';

export const useUnitTypesQuery = () => {
  const service = useMemo(() => new UnitTypeService(), []);
  const queryKey = ['useUnitTypesQuery'];

  const { data, isLoading, error } = useQuery(queryKey, async () => {
    return await service.getUnitTypes();
  });

  return {
    unitTypes: data,
    isLoading,
    error,
  };
};
